import React from 'react'
import LinkMedia from './LinkMedia'
import StylesSideNav from './StylesSideNav'

function Styles()  { const sideNav={
  padding: "10px 15px 0",
  height: "100%",
  boxSizing: "border-box"
}
return (
  <div className='flex w-[280px] '>
  <div style={{ flex: '1 1 280px', textAlign:'left' }}>
    <div style={sideNav}>
<StylesSideNav/>
</div>
</div> 
</div>
)

}

export default Styles